import { type ClientInferRequest } from "@ts-rest/core";

import { client } from "~/api/client";

import { type apiContract } from "../contract";

export type GetTillUserProductsRequest = ClientInferRequest<
  typeof apiContract.v1.pos.tills.getUserProducts
>;

export async function getUserProducts(
  tillId: string,
  query: GetTillUserProductsRequest["query"]
) {
  const response = await client.v1.pos.tills.getUserProducts({
    params: { tillId },
    query
  });

  if (response.status === 200) {
    return response.body;
  }

  throw response;
}
